var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import CoreEditor from '@toast-ui/editor';
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootEl = React.createRef();
        return _this;
    }
    Editor.prototype.getRootElement = function () {
        return this.rootEl.current;
    };
    Editor.prototype.getInstance = function () {
        return this.editorInst;
    };
    Editor.prototype.getBindingEventNames = function () {
        var _this = this;
        return Object.keys(this.props)
            .filter(function (key) { return /^on[A-Z][a-zA-Z]+/.test(key); })
            .filter(function (key) { return _this.props[key]; });
    };
    Editor.prototype.bindEventHandlers = function (props) {
        var _this = this;
        this.getBindingEventNames().forEach(function (key) {
            var eventName = key[2].toLowerCase() + key.slice(3);
            _this.editorInst.off(eventName);
            _this.editorInst.on(eventName, props[key]);
        });
    };
    Editor.prototype.getInitEvents = function () {
        var _this = this;
        return this.getBindingEventNames().reduce(function (acc, key) {
            var eventName = (key[2].toLowerCase() +
                key.slice(3));
            acc[eventName] = _this.props[key];
            return acc;
        }, {});
    };
    Editor.prototype.componentDidMount = function () {
        this.editorInst = new CoreEditor(__assign(__assign({ el: this.rootEl.current }, this.props), { events: this.getInitEvents() }));
    };
    Editor.prototype.shouldComponentUpdate = function (nextProps) {
        var instance = this.getInstance();
        var height = nextProps.height, previewStyle = nextProps.previewStyle;
        if (height && this.props.height !== height) {
            instance.setHeight(height);
        }
        if (previewStyle && this.props.previewStyle !== previewStyle) {
            instance.changePreviewStyle(previewStyle);
        }
        this.bindEventHandlers(nextProps);
        return false;
    };
    Editor.prototype.render = function () {
        return React.createElement("div", { ref: this.rootEl });
    };
    return Editor;
}(React.Component));
export { Editor };
